/**
 * Populates and appends option elements from  selectElm's data-list-data
 * attribute, which is a JSON array of { value: '', text: '' } objects.
 * @param {HTMLSelectElement} selectElm - a select element.
 */
export default function populateSelectOptions(selectElm, appendFirstOption = true) {
  // set up custom errors
  const listDataError = new Error("parsed listData must be formed as an array of { value: '', text: '', selected: 'true' } items");
  const listDataJSONError = new Error("listData must be valid JSON");
  const notASelectError = new Error("Argument selectElm must be a select element");

  // This code requires a select node
  if(selectElm.nodeName !== 'SELECT') {
    throw notASelectError;
  }

  // create a default first option
  const firstOption = document.createElement('option');
  firstOption.classList.add('js-first-option');
  firstOption.setAttribute('value', 0);

  // Parse, validate data-list-data attribute
  // If valid, write option elements.
  let parsedListData;
  const listAttr = selectElm.getAttribute('data-list-data');
  parsedListData = parseJSON(listAttr);
  if (validateListData()) {
    writeOptions();
  }

  /**
   * Clears selectElm's innerHTML and populates the options,
   * adding a default first option. Selects either the
   * selected item from data-list-data or the default first option.
   */
  function writeOptions() {
    selectElm.innerHTML = '';

    if(appendFirstOption) {
      selectElm.append(firstOption.cloneNode());
    }

    parsedListData.forEach((item) => {
      const opt = document.createElement('option');
      opt.setAttribute('value', item.value);
      opt.innerHTML = item.text;
      selectElm.append(opt);
      if (item.selected === true) {
        opt.selected = true;
      }

      if(appendFirstOption) {
        if (selectElm.value === undefined) {
          selectElm.querySelector('.js-first-option').selected = true;
        }
      }
    });
  }

  /**
   * Returns parsed JSON or throws.
   * @param {string} value - a JSON string
   * @return the parsed JSON.
   */
  function parseJSON(value) {
    let parsed;
    try {
      parsed = JSON.parse(value);
    } catch (error) {
      throw listDataJSONError;
    }
    return parsed;
  }

  /**
   * Validates that the parsed list data is an Array of { value: '', text: ''} objects.
   */
  function validateListData() {
    if (!Array.isArray(parsedListData)) {
      throw listDataError;
    }
    parsedListData.forEach((item) => {
      if (item.value === undefined || item.text === undefined) {
        throw listDataError;
      }
    });
    return true;
  }
}
